import React from "react";
import { motion } from "framer-motion";

const TextLabel = ({
  infoObjectName,
  path,
  name,
  data,
  rendererOptions: { hideKeys, color, ...styles },
}) => {
  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.25rem",
    maxWidth: "20rem",
    overflow: "hidden",
    color: color || "inherit",
    padding: 0,
    ...styles,
  };

  const valueStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.875rem",
  };

  return (
    <motion.div
      style={wrapperStyle}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      data-renderer="text-label"
    >
      <span style={valueStyle}>{data?.toString() || ""}</span>
    </motion.div>
  );
};

export default TextLabel;
